import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "../Components/Layout/Header/Header";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import { useLanguage } from "../context/LanguageContext";

function VideoPlayer() {
  const { language } = useLanguage();
  const { id } = useParams();
  const [videoData, setVideoData] = useState({
    url: "",
    title_english: "",
    title_arabic: ""
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVideo = async () => {
      try {
        const res = await handleApiCall("get", endpoints.newsList);
        const list = res?.data?.data?.data || [];

        const video = list.find(item => item._id === id);

        setVideoData({
          url: video?.desktop_news || "",
          title_english: video?.title_english || "",
          title_arabic: video?.title_arabic || ""
        });
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchVideo();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="pt-24 text-center">Loading...</div>
      </div>
    );
  }

  if (!videoData.url) {
    return (
      <div className="min-h-screen bg-white">
        <Header />
        <div className="pt-24 text-center">Video not found</div>
      </div>
    );
  }
  const title =
  language === "AR"
    ? videoData.title_arabic || videoData.title_english
    : videoData.title_english;

  return (
    <div >
      {/* HEADER */}
      <Header />

      {/* CONTENT */}
      <div className="pt-24 md:px-6 max-w-7xl mx-auto">
        

        {/* VIDEO */}
        {/* TITLE */}
        <div className="md:max-w-[75%] mx-auto overflow-hidden">
          <h1
            className={`text-xl md:text-2xl font-semibold mb-4 text-white ${
              language === "AR" ? "text-right" : "text-left"
            }`}
          >
            {title}
          </h1>
          <video
            src={videoData.url}
            controls
            autoPlay
            playsInline
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
}

export default VideoPlayer;
